import  CreateProfile from './CreateProfile';

export default  CreateProfile;


// WEBPACK FOOTER //
// ./src/components/pages/CreateProfile/index.js